/**
 * @since     1.0.0
 * @author    Jonas Hartmann <mail@inoas.com>
 * @license   For full copyright and license information, please see the LICENSE.txt.
 */
'use strict';

var isValidIban = function(value) {
    return value.match(/^([A-Z]){2}([0-9]){2}([0-9A-Z]){12,30}$/g) === null;
    // return value.match(/^DE([0-9]){20,32}$/g) === null
    //     && value.match(/^NL([0-9]){2,2}([A-Z]){4,4}([0-9]){10,10}$/g) === null;
};

var runHtml5IbanValidation = function(elm, noSpaces) {
    var noSpaces = (typeof noSpaces !== 'undefined') ?  noSpaces : false;
    elm.value = elm.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    // /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/,
    if (isValidIban(elm.value) === true) {
        elm.reportValidity = true;
        elm.setAttribute('pattern', /^(THIS_IS_INVALID)$/);
    } else {
        elm.removeAttribute('pattern');
    }
    if (noSpaces === true) {
        elm.value = elm.value.replace(/[^A-Z0-9]/g, '');
    } else {
        elm.value = elm.value.replace(/(.{4})/g, '$1 ').trim();
    }
};

dispatchAfterJqueryHasLoaded(function () {
    var _overlay = document.getElementById('menu--mobile-list');
    if (_overlay != null) {
        var _clientY = null; // Remember Y position on touch start
        var isOverlayTotallyScrolled = function() {
            // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
            return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
        }
        var disableRubberBand = function (event) {
            var clientY = event.targetTouches[0].clientY - _clientY;
            if (_overlay.scrollTop === 0 && clientY > 0) {
                // Element is at the top of its scroll
                event.preventDefault();
            }
            if (isOverlayTotallyScrolled() && clientY < 0) {
                // Element is at the top of its scroll
                event.preventDefault();
            }
        };
        _overlay.addEventListener('touchstart', function (event) {
            if (event.targetTouches.length === 1) {
                // Detect single touch
                _clientY = event.targetTouches[0].clientY;
            }
        }, false);
        _overlay.addEventListener('touchmove', function (event) {
            if (event.targetTouches.length === 1) {
                // Detect single touch
                disableRubberBand(event);
            }
        }, false);
    }

    $('.info-icon').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).next().toggleClass('info-icon-text-active');
        return false;
    });

    $('.info-icon-text').click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).toggleClass('info-icon-text-active');
        return false;
    });

    $('#cookie-disclaimer-box-hide-action').on('click touch', function() {
        $('#cookie-disclaimer-box').addClass('d-none');
        $.post('/api/users/xhr-accept-cookies', function() {
                //console.log('success');
            })
            .done(function() {
                //console.log('second success');
            })
            .fail(function() {
                //console.log('error');
            })
            .always(function() {
                //console.log('finished');
            })
        ;
    });
});
